import html2canvas from 'html2canvas';

/**
 * Exports a DOM element to PNG image
 * @param {HTMLElement} element - The DOM element to export
 * @param {string} filename - The filename for the downloaded image
 */
export const exportToPNG = async (element, filename = 'quiz-result.png') => {
  try {
    const canvas = await html2canvas(element, {
      backgroundColor: '#ffffff',
      scale: 2,
      logging: false,
      useCORS: true,
      allowTaint: true
    });
    
    const dataUrl = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.download = filename;
    link.href = dataUrl;
    link.click();
  } catch (error) {
    console.error('Error exporting to PNG:', error);
    alert('Hubo un error al exportar la imagen. Por favor intenta de nuevo.');
  }
};

/**
 * Shares an element as PNG (uses Web Share API if available)
 * @param {HTMLElement} element - The DOM element to share
 * @param {string} filename - The filename for the shared image
 */
export const shareToPNG = async (element, filename = 'quiz-result.png') => {
  try {
    const canvas = await html2canvas(element, {
      backgroundColor: '#ffffff',
      scale: 2,
      logging: false,
      useCORS: true,
      allowTaint: true
    });
    
    canvas.toBlob(async (blob) => {
      if (!blob) {
        throw new Error('Failed to create blob');
      }
      
      // Try Web Share API if available
      if (navigator.share && navigator.canShare) {
        const file = new File([blob], filename, { type: 'image/png' });
        const shareData = {
          files: [file],
          title: 'Mi resultado en Quiz de Anatomía'
        };
        
        if (navigator.canShare(shareData)) {
          try {
            await navigator.share(shareData);
            return;
          } catch (err) {
            if (err.name !== 'AbortError') {
              console.log('Web Share API failed, falling back to download');
            }
          }
        }
      }
      
      // Fallback to download
      const dataUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.download = filename;
      link.href = dataUrl;
      link.click();
      URL.revokeObjectURL(dataUrl);
    });
  } catch (error) {
    console.error('Error sharing PNG:', error);
    alert('Hubo un error al compartir la imagen. Por favor intenta de nuevo.');
  }
};
